import React, { createContext, useContext, useEffect, useState } from "react";
import { authLogin, authMe, authUpdateProfile } from "../lib/api";

const AuthContext = createContext(null);
const TOKEN_KEY = "rfl_crm_token";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }
    authMe(token)
      .then((u) => {
        if (u.role === "admin" || u.role === "consultant") setUser(u);
        else {
          localStorage.removeItem(TOKEN_KEY);
          setToken(null);
        }
      })
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        setToken(null);
      })
      .finally(() => setLoading(false));
  }, [token]);

  // Staff login — only admin role accepted in the back office.
  const login = async (email, password) => {
    try {
      const data = await authLogin({ email, password });
      if (data.user.role !== "admin" && data.user.role !== "consultant") {
        return { ok: false, error: "This portal is for staff only." };
      }
      localStorage.setItem(TOKEN_KEY, data.token);
      setToken(data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e?.response?.data?.detail || "Invalid email or password" };
    }
  };

  const updateProfile = async ({ name, avatar, phone }) => {
    try {
      const u = await authUpdateProfile(token, { name, avatar, phone });
      setUser(u);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: "Could not save your profile." };
    }
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading, updateProfile }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
